
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingRankings = View.Rankings.extend({
		template: JST.TippingRankings,
		ui: {
			'swipe_table':  '.js-swipe-table',
			'round_select': '.js-round-select',
			'sort_th':      '.js-sort-th',
			'load_more':    '.js-load-more',
			'search_me'   : '.js-search-me-rankings',
			'search_me_list' : '.ranking-autocomplete li'
		},
		initialize: function() {
			this.showPreloader()
				.scrollToTop();

			this.rankings        = this.getOption('rankings');
			this.rounds          = this.getOption('rounds');
			this.user            = this.getOption('user');
			this.offset          = 0;
			this.limit           = 50;
			this.is_all          = false;
			this.sort_key        = 'overall_rank';
			this.sort_order      = true;
			this.scroll_pos      = null;
			this.reverse_keys    = ['overall_rank', 'round_rank', 'team_name'];
			this.order_direction = $.inArray(this.sort_key, this.reverse_keys) != -1 ? !this.sort_order : this.sort_order;
			this.autocomplete    = false;
			this.search_val      = '';
			this.cachRankings    = [];

			var complete = [
				this.rounds.fetch({ cache: true, expires: 60 }),
				this.rankings.show_user_rankings().fetch({ data: { order: this.sort_key, order_direction: this.order_direction ? 'DESC' : 'ASC', offset: this.offset } })
			];

			$.when.apply(null, complete).done(_.bind(function() {
				this.is_all = this.rankings.length < this.limit;

				return this.checkSelectedRound()
						   .setModelData()
						   .render()
						   .hidePreloader();
			}, this));
		},

		checkSelectedRound() {
			return this;
		},

		initRankingsData: function() {
			this.showPreloader();
			this.scroll_pos      = this.ui.swipe_table && typeof this.ui.swipe_table.scrollLeft === 'function' ? this.ui.swipe_table.scrollLeft() : 0;
			this.order_direction = $.inArray(this.sort_key, this.reverse_keys) != -1 ? !this.sort_order : this.sort_order;

			var data  = { order: this.sort_key, order_direction: this.order_direction ? 'DESC' : 'ASC', offset: this.offset };
			if (_.isNumber(this.round_id)) {
				this.sort_key = 'round_rank';
				data.round = this.round_id;
				data.order = this.sort_key;
			}
			else { // if no round id then assume all rounds
				this.sort_key = 'overall_rank';
				data.order = this.sort_key;
			}

			this.rankings
				.show_user_rankings()
				.fetch({remove: !Boolean(this.offset), data: data})
				.done(_.bind(function() {
					this.is_all = (this.rankings.length - this.offset) < this.limit;

					return this.setModelData().render().hidePreloader();
				}, this));

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));